import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm.54-4.29c-.33.16-.54.49-.54.84V14h-1.5v-.45c0-.93.55-1.8 1.4-2.2.51-.24.97-.84.83-1.63-.1-.59-.61-1.1-1.2-1.2A1.498 1.498 0 0010.5 10H9c0-.89.39-1.73 1.08-2.3a2.993 2.993 0 014.87 1.77c.24 1.33-.45 2.66-1.66 3.24z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm.87-4.86c-.52.25-.86.78-.86 1.35V15h-1.5v-.51c0-1.15.67-2.21 1.72-2.71.92-.44 1.42-1.42 1.24-2.44-.16-.9-.9-1.64-1.8-1.8-.68-.12-1.33.05-1.85.48s-.81 1.06-.81 1.73h-1.5c0-1.11.49-2.16 1.35-2.88.85-.71 1.97-1.01 3.07-.81 1.51.26 2.75 1.5 3.02 3.02.3 1.7-.54 3.33-2.08 4.06z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm1.74-9.72c-1.04.5-1.72 1.56-1.72 2.7V30h-3v-1.02c0-2.3 1.34-4.42 3.44-5.42 1.84-.88 2.84-2.84 2.48-4.88-.32-1.8-1.8-3.28-3.6-3.6-1.36-.24-2.66.1-3.7.96a4.462 4.462 0 00-1.62 3.46h-3c0-2.22.98-4.32 2.7-5.76a7.476 7.476 0 016.14-1.62c3.02.52 5.5 3 6.04 6.04.6 3.4-1.08 6.66-4.16 8.12z"
  }))
};
export var QuestionCircleFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});